import React from 'react'

interface TodoStatsProps {
  itemsLeft: number
  onClearCompleted: () => void
}

const TodoStats: React.FC<TodoStatsProps> = ({ itemsLeft, onClearCompleted }) => {
  return (
    <div className="todo-stats">
      <span id="items-left">
        {itemsLeft} item{itemsLeft !== 1 ? 's' : ''} left
      </span>
      <button id="clear-completed" onClick={onClearCompleted}>
        Clear completed
      </button>
    </div>
  )
}

export default TodoStats 